import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import loginIllustration from "../assets/images/login-illustration.svg";

function ResetPassword() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [successMessage, setSuccessMessage] = useState("");

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [serverError, setServerError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }

    if (serverError) setServerError("");
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = { password: "", confirmPassword: "" };

    if (!formData.password) {
      newErrors.password = "A senha é obrigatória";
      valid = false;
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "As senhas não coincidem";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await fetch(
        `https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/user/reset-password/${token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ newPassword: formData.password }),
        }
      );

      if (response.ok) {
        setSuccessMessage("Senha redefinida com sucesso!");
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setSuccessMessage("");
      }
    } catch (error) {
      console.error("Erro ao recuperar senha:", error);
      setServerError("Erro inesperado. Tente novamente mais tarde.");
      setSuccessMessage("");
    }
    finally {
      setLoading(false);
    }
  };

  const isFormValid =
    formData.password &&
    formData.confirmPassword &&
    formData.password === formData.confirmPassword &&
    !errors.password &&
    !errors.confirmPassword;

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="image-section">
          <div className="image-content">
            <img
              src={loginIllustration}
              alt="Login illustration"
              className="login-image"
            />
            <div className="carousel-indicators">
              <svg
                width="89"
                height="16"
                viewBox="0 0 89 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="8.5" cy="8" r="8" fill="#4285F3"></circle>
                <circle cx="32.5" cy="8" r="8" fill="#C6DCFF"></circle>
                <circle cx="56.5" cy="8" r="8" fill="#C6DCFF"></circle>
                <circle cx="80.5" cy="8" r="8" fill="#C6DCFF"></circle>
              </svg>
            </div>
          </div>
        </div>
        <div className="form-section">
          <div className="form-container">
            <form className="login-form-wrapper" onSubmit={handleSubmit}>
              <div className="form-header">
                <div className="form-title">Redefinir Senha</div>
                <div className="form-subtitle">
                  Entre com sua nova senha
                </div>
              </div>

              <div className="form-content">
                <div className="form-fields">
                  <div className="form-field">
                    <div className={`input-container ${errors.password ? "input-error" : ""}`}>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Digite sua senha"
                      />
                      <div className="password-toggle" onClick={togglePasswordVisibility}>
                        {showPassword ? (
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_886_2866)">
                              <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#4285F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M2 12C3.60014 7.90264 7.33603 5 12 5C16.664 5 20.3999 7.90264 22 12C20.3999 16.0974 16.664 19 12 19C7.33603 19 3.60014 16.0974 2 12Z" stroke="#4285F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_886_2866">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        ) : (
                          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_886_5106)">
                              <path d="M11.2302 5.07319C11.6449 5.02485 12.0685 5 12.5 5C17.164 5 20.8999 7.90264 22.5 12C22.1054 13.0104 21.5809 13.9482 20.9447 14.7877M7.01962 6.51944C4.97955 7.76406 3.40111 9.69259 2.5 12C4.10014 16.0974 7.83603 19 12.5 19C14.5376 19 16.398 18.446 17.9806 17.4804M10.3788 9.87859C9.83582 10.4215 9.5 11.1715 9.5 12C9.5 13.6569 10.8431 15 12.5 15C13.3285 15 14.0785 14.6642 14.6214 14.1212" stroke="#4285F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M4.5 4L20.5 20" stroke="#4285F3" stroke-width="2" stroke-linecap="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_886_5106">
                                <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                      </div>
                    </div>
                    {errors.password && (
                      <div className="error-message">{errors.password}</div>
                    )}
                  </div>
                  <div className="form-field">
                    <div className={`input-container ${errors.confirmPassword ? "input-error" : ""}`}>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Confirme sua senha"
                      />
                      <div className="password-toggle" onClick={togglePasswordVisibility}>
                        {showPassword ? (
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_886_2866)">
                              <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#4285F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M2 12C3.60014 7.90264 7.33603 5 12 5C16.664 5 20.3999 7.90264 22 12C20.3999 16.0974 16.664 19 12 19C7.33603 19 3.60014 16.0974 2 12Z" stroke="#4285F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_886_2866">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        ) : (
                          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_886_5106)">
                              <path d="M11.2302 5.07319C11.6449 5.02485 12.0685 5 12.5 5C17.164 5 20.8999 7.90264 22.5 12C22.1054 13.0104 21.5809 13.9482 20.9447 14.7877M7.01962 6.51944C4.97955 7.76406 3.40111 9.69259 2.5 12C4.10014 16.0974 7.83603 19 12.5 19C14.5376 19 16.398 18.446 17.9806 17.4804M10.3788 9.87859C9.83582 10.4215 9.5 11.1715 9.5 12C9.5 13.6569 10.8431 15 12.5 15C13.3285 15 14.0785 14.6642 14.6214 14.1212" stroke="#4285F3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M4.5 4L20.5 20" stroke="#4285F3" stroke-width="2" stroke-linecap="round" />
                            </g>
                            <defs>
                              <clipPath id="clip0_886_5106">
                                <rect width="24" height="24" fill="white" transform="translate(0.5)" />
                              </clipPath>
                            </defs>
                          </svg>
                        )}
                      </div>
                    </div>
                    {errors.confirmPassword && (
                      <div className="error-message">{errors.confirmPassword}</div>
                    )}
                  </div>
                  {successMessage && (
                    <div className="success-message">
                      {successMessage}
                    </div>
                  )}
                </div>

                {serverError && <div className="error-message">{serverError}</div>}

                <div className="form-actions">
                  <button type="submit"
                    className={`login-button ${!isFormValid || loading ? "button-disabled" : ""}`}
                    disabled={!isFormValid || loading}>
                    {loading ? "Alterarando..." : "Alterar Senha"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
